import useFetch from '@hooks/useFetch';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { emptyObject } from '@constants/empty';
import { getIsLoggedIn } from '@api/selectors/auth';
import { HOST_TYPE } from '@utils/api-helper/host';

const useDailyTaskHistory = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = 'v3/gamification/daily_task/history/';
  const { data: dailyTaskHistory, ...rest } = useFetch(
    isLoggedIn ? key : null,
    { hostType: HOST_TYPE.BACKEND_API_HOST }
  );
  return { dailyTaskHistory: dailyTaskHistory || emptyObject, ...rest };
};

export default useDailyTaskHistory;
